import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import svgData from "./svgData";
import { PathElement } from "../../svgHelpers";
const ClipboardTextFill = (props) => (_jsx(_Fragment, { children: _jsx(PathElement, { ...props, path: svgData.path.d }) }));
export default ClipboardTextFill;
